import type { EnvelopeField } from '../../api/types/esign.interfaces'
import { genId, presetFromFieldMeta, resolveESignFieldType } from './fieldType'
import type { Box } from './types'

export function dedupeEnvelopeFields(fields: EnvelopeField[]): EnvelopeField[] {
	const seen = new Set<string>()
	return fields.filter((f) => {
		const id =
			typeof f.id === 'string' && f.id
				? f.id
				: `${f.page}-${f.positionX}-${f.positionY}-${f.recipientId}`
		if (seen.has(id)) return false
		seen.add(id)
		return true
	})
}

function resolveBoxType(field: EnvelopeField): Box['type'] {
	if (
		resolveESignFieldType({
			type: field.type,
			meta: field.fieldMeta as Record<string, unknown> | undefined,
		}) === 'INITIALS'
	) {
		return 'INITIALS'
	}
	const upperType = String(field.type ?? 'TEXT').toUpperCase()
	if (upperType === 'SIGNATURE') {
		return 'SIGNATURE'
	}
	return 'TEXT'
}

export function envelopeFieldsToBoxes(fields: EnvelopeField[]): Box[] {
	return fields.map((f) => ({
		id: typeof f.id === 'string' ? f.id : genId(),
		recipientId: String(f.recipientId ?? ''),
		type: resolveBoxType(f),
		pageNumber: Number(f.page) || 1,
		pageX: Number(f.positionX ?? f.pageX) ?? 0,
		pageY: Number(f.positionY ?? f.pageY) ?? 0,
		pageWidth: Number(f.width ?? f.pageWidth) ?? 30,
		pageHeight: Number(f.height ?? f.pageHeight) ?? 8,
		preset: presetFromFieldMeta(
			f.fieldMeta as Record<string, unknown> | undefined,
		),
	}))
}
